module.exports = __webpack_public_path__ + "img/pdf-dark-icon.78482a33.svg";